export var listItemHeaderMediaStyles = {
  root: function root(_ref) {
    var v = _ref.variables;
    return {
      alignSelf: 'flex-end',
      fontSize: v.headerMediaFontSize,
      lineHeight: v.headerMediaLineHeight
    };
  }
};
//# sourceMappingURL=listItemHeaderMediaStyles.js.map
